import { makeStyles } from "tss-react/mui";
import { Box, Theme } from "@mui/material";
import { SeparatorType } from "../Separator";
import { COLUMN_WIDTH } from "./chartView.constants";
import { ColumnHeaderNodeData } from "./chartView.types";

const separatorConfigs = (
  theme: Theme
): Record<
  string,
  { backgroundColor: string; borderColor: string; fontColor: string }
> => ({
  [SeparatorType.OrderStart]: {
    backgroundColor: theme.palette.primary.medium || "#1976d2",
    borderColor: theme.palette.cyan.dark,
    fontColor: theme.palette.primary.contrastText,
  },
  [SeparatorType.PriorToOrder]: {
    backgroundColor: theme.palette.info.main,
    borderColor: theme.palette.lightblue.main,
    fontColor: theme.palette.info.contrastText,
  },
  [SeparatorType.AfterOrder]: {
    backgroundColor: theme.palette.success.main,
    borderColor: theme.palette.green.main,
    fontColor: theme.palette.success.contrastText,
  },
});

export const ColumnHeader = ({ data }: { data: ColumnHeaderNodeData }) => {
  const { classes } = useStyles({ type: data.type });

  return <Box className={classes.container}>{data.title}</Box>;
};

const useStyles = makeStyles<{ type: SeparatorType }>()((theme, { type }) => {
  const config = separatorConfigs(theme)[type];
  return {
    container: {
      background: config.backgroundColor,
      border: `1px solid ${config.borderColor}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(0.75, 4),
      color: config.fontColor,
      fontWeight: theme.fontWeight.semiBold,
      fontSize: theme.fontSize.small,
      width: COLUMN_WIDTH,
      boxSizing: "border-box",
      whiteSpace: "nowrap",
    },
  };
});
